import React, {Component} from 'react';
import Select from 'react-select';

class LabellingToolBar extends Component {
    
    constructor(props) {
        super(props);
        this.state = {
            text_options: [],
            image_options: []
        }
    }

    set_value = (field,value,index) => {
        var labels
        var sel = this.props.design_selection
        if(sel){
            if(sel.class_type == 'background'){
                labels = window.design_editor.active_page.background.labels
            }else if(sel.get_parent('box') && sel.get_parent('box').image){
                labels = sel.get_parent('box').image.labels
            }else if(sel.type === 'image' || sel.type === 'text'){
                labels = sel.labels
            }

        }

        if(labels){
            labels[field] = value
        }

        this.setState({})
    }

    getOption = (value) => {
        for (var i = 0; i < this.state.text_options.length; i++) {
            if(this.state.text_options[i].value === value){
                return this.state.text_options[i]
            }
        }

        for (var i = 0; i < this.state.image_options.length; i++) {
            if(this.state.image_options[i].value === value){
                return this.state.image_options[i]
            }
        }

        return ''
    }

    componentDidMount() {
        fetch(global.config.server_path + 'tag/get_all_labels', {method: 'POST','credentials': 'include',headers: {'Content-Type':'application/json'}, body:JSON.stringify({})} )
        .then(resp => resp.json())
        .then(data => {
            if(data.response_code === 1){
                var labels = data.data;
                var t = []; var im = [];
                for (var i = 0; i < labels.length; i++) {
                    if(labels[i].type === 'image'){
                        im.push({label: labels[i].name,value:labels[i]._id});
                    }else if(labels[i].type === 'text'){
                        t.push({label: labels[i].name,value:labels[i]._id});
                    }
                }

                this.setState({text_options:t,image_options:im})
            }
        })

    }

    componentWillUnmount() {
    
    }


    set_state = async state => new Promise(resolve => this.setState(state, resolve));

    render() {
        var dropdown = (<div></div>)

        if(this.props.label_rules){
            var label_rules = this.props.label_rules
            var labels
            var sel = this.props.design_selection

            if(sel){
                if(sel.class_type == 'background'){
                    labels = window.design_editor.active_page.background.labels
                }else if(sel.get_parent('box') && sel.get_parent('box').image){
                    labels = sel.get_parent('box').image.labels
                }else if(sel.type === 'image' || sel.type === 'text'){
                    labels = sel.labels
                }

            }

            if(label_rules === 'text'){
                dropdown = (
                    <div style={{'width': '150px'}}><Select placeholder="text label..." value={labels?this.getOption(labels.text):''} options={this.state.text_options} onChange={(selection) => {this.set_value('text',selection.value) }}/></div>
                )
            }

            if(label_rules === 'image'){
                dropdown = (
                    <div style={{'width': '150px'}}><Select placeholder="image label..." value={labels?this.getOption(labels.image):''} options={this.state.image_options} onChange={(selection) => {this.set_value('image',selection.value) }}/></div>
                )
            }
        }

        return (
            <div style={{'display': 'inline-flex', 'fontSize': 'small', 'fontWeight': 'lighter'}}>
                {dropdown}
            </div>
        )
    }
}

export default LabellingToolBar;